import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';
import { ExecuteResult } from '@/model/common';
import { CustomColumnItem } from '@/business-components/custom-column';

/**
 * 查询报表字段
 * @param data
 * @returns
 */
export const getReportFields = (data: any): Promise<ExecuteResult<Array<CustomColumnItem>>> => {
  const url = getAgpApiUrl('dservice/metadata', 'account_list_fields');
  return smb_fetch(url, {
    method: 'GET',
    data,
  }, false, false);
};
